
$(function () {

    var _init = function () {
        $.fn.check = function (isChecked) {

            var isCheckboxInput = $(this).parents(".widget-checkbox").length > 0;
            var isCheckboxWrapper = $(this).is(".widget-checkbox");

            if (isCheckboxInput || isCheckboxWrapper) {

                if (isCheckboxInput && $(this).attr("disabled")) return;
                if (isCheckboxWrapper && $(this).find("input").attr("disabled")) return;

                var usingValue =
                    (isCheckboxInput && $(this).parents(".widget-checkbox").data("using-value"))
                    ||
                    (isCheckboxWrapper && $(this).data("using-value"));

                if (isChecked) {
                    $(this).prop("checked", true);
                    $(this).find("input").prop("checked", true);
                    
                }
                else {
                    $(this).prop("checked", false);
                    $(this).find("input").prop("checked", false);
                }

                if (!usingValue) {
                    $(this).val(isChecked.toString());
                    $(this).find("input").val(isChecked.toString());
                }
            }
        };

        $.fn.isChecked = function () {
            return $(this).find("input").is(":checked") || $(this).is(":checked");
        };
    };

    _init();

    $(".widget-checkbox input").on("change", function () {
        var checked = $(this).is(":checked");
        var usingValue = $(this).parents(".widget-checkbox").data("using-value");

        if (usingValue != "true" && usingValue != true) {
            $(this).val(checked.toString());
        }

        $(this).trigger(WidgetEvents.STEMS_ON_CHANGE, checked);
    })
})